export default {
  reservationInfo: {},
};
